
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"34","height":"34","rx":"3","fill":"#122B79"}}),_c('path',{attrs:{"d":"M20.784 23.184h-7.568V9.816h7.568v13.368z","fill":"#6C6BBD"}}),_c('path',{attrs:{"d":"M13.697 16.5c0-2.708 1.29-5.126 3.303-6.684A8.71 8.71 0 0011.652 8C6.872 8 3 11.804 3 16.5S6.872 25 11.652 25A8.71 8.71 0 0017 23.184c-2.012-1.558-3.303-3.965-3.303-6.684z","fill":"#D32011"}}),_c('path',{attrs:{"d":"M31 16.5c0 4.696-3.872 8.5-8.652 8.5A8.71 8.71 0 0117 23.184c2.012-1.558 3.303-3.976 3.303-6.684S19.013 11.374 17 9.816A8.71 8.71 0 0122.348 8C27.128 8 31 11.804 31 16.5z","fill":"#0099DF"}})])
          )
        }
      }
    